import { Avatar, Stack, Tooltip } from '@mui/material';

function stringAvatar(name: string) {
  if (!name || name.trim() === '') {
    return {
      sx: {
        bgcolor: '#bdbdbd',
      },
      children: '??',
    };
  }

  const nameArray = name.trim().split(' ').filter(n => n.length > 0);
  let initials = '';
  
  if (nameArray.length === 0) {
    initials = '??';
  } else if (nameArray.length === 1) {
    // Single name - use first letter twice
    initials = `${nameArray[0][0].toUpperCase()}${nameArray[0][0].toUpperCase()}`;
  } else {
    // Multiple names - use first letter of first two names
    initials = `${nameArray[0][0].toUpperCase()}${nameArray[1][0].toUpperCase()}`;
  }

  return {
    sx: {
      bgcolor: '#bdbdbd',
    },
    children: initials,
  };
}

const BackgroundLetterAvatars = ({ userData }: any) => {
  return (
    <Stack direction="row" spacing={2}>
      <Tooltip title={userData?.given_name || 'Unknown User'}>
        <Avatar {...stringAvatar(userData?.given_name)} />
      </Tooltip>
    </Stack>
  );
}

export default BackgroundLetterAvatars;
